import PropTypes from 'prop-types'
import React from 'react'
import Button from './Button'
import Space from './Space'
import Link from './Link'
import ShowHide from './ShowHide'
import { FlexGrid, FlexItem } from './flexgrid'
import './EmptyPage.css'

const EmptyPage = props => (
  <div className='EmptyPage'>
    <ShowHide show={!!props.imageHref}>
      <img src={props.imageHref} className='EmptyPage-image' />
      <Space value='20' />
    </ShowHide>
    <h3>{props.title}</h3>
    <Space value='10' />
    <div className='EmptyPage-body'>
      {props.body}
    </div>
    <ShowHide show={!!props.footer}>
      <FlexGrid justifyContent='center'>
        <FlexItem>
          {props.footer}
        </FlexItem>
      </FlexGrid>
    </ShowHide>
    <Space value='30' />
    <ShowHide show={!!props.buttonText}>
      <FlexGrid justifyContent='center'>
        <FlexItem>
          <Button href={props.buttonHref} rel={props.rel} onClick={props.onButtonClick} icon={props.buttonIcon}>{props.buttonText}</Button>
        </FlexItem>
        <FlexItem>
          <ShowHide show={!!props.secondaryButtonText}>
            <Space type='horizontal' value='10' />
            <Button href={props.secondaryButtonHref} modifier='secondary'>{props.secondaryButtonText}</Button>
          </ShowHide>
        </FlexItem>
      </FlexGrid>
      <Space value='10' />
    </ShowHide>
    <ShowHide show={!!props.learnMoreHref}>
      <Link href={props.learnMoreHref} rel={props.learnMoreRel}>{props.learnMoreText}</Link>
    </ShowHide>
  </div>
)

EmptyPage.displayName = 'EmptyPage'

EmptyPage.defaultProps = {
  learnMoreText: 'Learn more'
}

EmptyPage.propTypes = {
  title: PropTypes.node.isRequired,
  onButtonClick: PropTypes.func,
  buttonText: PropTypes.string,
  buttonIcon: PropTypes.string,
  buttonHref: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonHref: PropTypes.string,
  learnMoreHref: PropTypes.string,
  learnMoreText: PropTypes.string,
  learnMoreRel: PropTypes.string,
  rel: PropTypes.string,
  imageHref: PropTypes.string,
  body: PropTypes.node.isRequired,
  footer: PropTypes.node
}

export default EmptyPage



// WEBPACK FOOTER //
// ./ui/EmptyPage.js